const CountryList = [
    { code: '64', name: "New Zealand", shortName: "NZ", currency: "NZD" },
    { code: '61', name: "Australia", shortName: "AU", currency: "AUD" }
];

const Countries = {}

Countries.all = CountryList;

Countries.getByCodes = (codes) => {
    return CountryList.filter(x => codes.indexOf(x.code) >= 0);
}

Countries.getByShortNames = (shortNames) => {
    return CountryList.filter(x => shortNames.indexOf(x.shortName) >= 0);
}

Countries.getByCurrencies = (currencies) => {
    return CountryList.filter(x => currencies.indexOf(x.currency) >= 0);
}

Countries.isAllowedShortName = (countries, shortName) => {
    return countries.filter(x => x.shortName === shortName).length > 0;
};

Countries.isAllowedCode = (countries, code) => {
    return countries.filter(x => x.code === code).length > 0;
};


module.exports = Countries;